import React, { useState, useEffect } from 'react'
import Handler from '../../Helpers/Components/Handler'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { reloadWindow, reloadWindowToPath } from '../../Helpers/Utils'
import DatePicker from 'react-multi-date-picker'
import moment from 'moment'

const View = ({ leadId }) => {
    const [viewData, setViewData] = useState({})
    const [updateData, setUpdateData] = useState(null)
    const [newNote, setNewNote] = useState("")
    const [remark, setRemark] = useState(null)
    const [loading, setLoading] = useState(false)
    const [carReq, setCarReq] = useState("")
    const [followUp, setFollowUp] = useState("")
    const [follow, setFollow] = useState({ phoneFollow: "", whatsappFollow: "" })
    const [data, setData] = useState({})
    const options = [
        { value: 'Following', label: 'Following' },
        { value: 'HFU', label: 'Hot Followup' },
        { value: 'RNR', label: 'RNR' },
        { value: 'Rejected', label: 'Rejected' },
        { value: 'Closed', label: 'Closed' },
        { value: 'Converted', label: 'Converted' }
    ]
    const remarkOption = [
        { value: 'Attended', label: 'Attended' },
        { value: 'Rejected', label: 'Rejected' },
        { value: 'Dropped', label: 'Dropped' },
        { value: 'Blocked', label: 'Blocked' },
        { value: 'Missed', label: 'Missed' },
        { value: 'Not Reachable', label: 'Not Reachable' },
        { value: 'RNR', label: 'RNR' },
        { value: 'Switch Off', label: 'Switch Off' }
    ]
    const checkData = async () => {
        const response = await Handler({ method: "get", url: `/lead/view/${leadId}` })
        if (response?.success) {
            setViewData(response.data)
            setFollow({ phoneFollow: response?.data?.phoneFollow || false, whatsappFollow: response.data?.whatsappFollow || false })
            setCarReq(response?.data?.carReq)
        }
    }
    const dayKey = (d) => moment(d).format("YYYY-MM-DD")
    const todayKey = () => moment().format("YYYY-MM-DD")
    const startOfToday = () => new Date(new Date().setHours(-1, 0, 0, 0))
    const endOfDay = (d) => new Date(new Date(d).setHours(23, 59, 59, 999))
    const isRnr = updateData?.value === "RNR"
    const needsFollow = updateData?.value === "Following" || updateData?.value === "HFU"
    const submitUpdate = async () => {
        const carReqChanged = !!carReq && (!viewData?.carReq || dayKey(carReq) !== dayKey(viewData?.carReq))
        if (!updateData?.value) {
            return toast.error("Please select a status")
        } else if (!newNote) {
            return toast.error("Please enter note")
        } else if (needsFollow && !followUp) {
            return toast.error("Please select a followUp date")
        } else if (needsFollow && !carReq) {
            return toast.error("Please select a Car Req date")
        } else if (!isRnr && followUp && dayKey(followUp) < todayKey()) {
            return toast.error("Follow up date should be today or later")
        } else if (!isRnr && carReqChanged && dayKey(carReq) < todayKey()) {
            return toast.error("Car req date should be today or later")
        } else if (!isRnr && followUp && carReq && dayKey(followUp) > dayKey(carReq)) {
            return toast.error("Follow up date should not be after the car req date")
        }
        // else if (!follow.phoneFollow) {
        //     return toast.error("Please select a phone follow")
        // } else if (!follow.whatsappFollow) {
        //     return toast.error("Please select a whatsapp follow")
        // } 
        else {
            setLoading(true)
            const body = isRnr ? { status: updateData?.value, note: newNote } : {
                status: updateData?.value,
                note: newNote,
                ...(remark?.value ? { remark: remark?.value } : {}),
                ...(carReqChanged ? { carReq: dayKey(carReq) } : {}),
                ...(data?.days ? { days: data.days } : {}),
                ...(data?.message ? { message: data?.message } : {}),
                ...(data?.carType ? { carType: data?.carType } : {}),
                ...(followUp ? { followUp: dayKey(followUp) } : {}),
                ...(follow.phoneFollow ? { phoneFollow: follow.phoneFollow ? follow.phoneFollow.value : "" } : {}),
                ...(follow.whatsappFollow ? { whatsappFollow: follow.whatsappFollow ? follow.whatsappFollow.value : "" } : {})
            }
            const response = await Handler({ method: "patch", url: `/lead/update/notes/${leadId}`, data: body })
            if (response?.success) {
                if (updateData?.value === "Converted" && !response?.data?.isCustomer) {
                    reloadWindowToPath(`/booking/register?name=${viewData?.name}&number=${viewData?.phone}`)
                }
                toast.success("Updated Successfully");
                setTimeout(reloadWindow, 1500)
            } else {
                setLoading(false)
                toast.error(response?.message || "Update Failed")
            }
        }

    }
    useEffect(() => {
        if (leadId) checkData()
    }, [leadId])
    return (
        <React.Fragment>
            <div className="p-3">
                <div className='mb-3'>
                    <label className="form-label fw-bold">Status</label>
                    <Select isDisabled={loading}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        options={options} value={updateData} onChange={(item) => { if (item.value === "Rejected") { setRemark({ value: 'Rejected', label: 'Rejected' }) } else { setRemark() } setUpdateData(item) }} />
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">Car Req Date</label>
                    <div className=' datepicker-top'><DatePicker
                        format='DD/MM/YYYY'
                        disabled={loading}
                        minDate={startOfToday()}
                        onChange={(e) => { setCarReq(e ? new Date(e) : "") }}
                        value={carReq}
                    />
                    </div>
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">Car Type</label>
                    <Select isDisabled={loading}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        options={[
                            { label: "SUV", value: "SUV" },
                            { label: "Hatchback", value: "Hatchback" },
                            { label: "Comfy Hatchback", value: "Comfy Hatchback" },
                            { label: "Sedan", value: "Sedan" },
                            { label: "Small Cars", value: "Small Cars" },
                            { label: "Auto Cars", value: "Auto Cars" },
                            { label: "Mini SUV", value: "Mini SUV" },
                        ]} value={data?.carType ? { label: data?.carType, value: data?.carType } : ""} onChange={(item) => { setData((prev) => ({ ...prev, carType: item?.value })) }} />
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">No. of Days Req</label>
                    <input autoComplete='off' type="text" disabled={loading} className="form-control input-theme" name="days" value={data?.days || ""} onChange={(e) => { if (Number(e.target.value) == e.target.value) setData(Prev => ({ ...Prev, days: e.target.value })) }} placeholder="Enter Number of days car is required" />
                </div>
                <div className='mb-3'>
                    <label className="form-label fw-bold">Add Notes</label>
                    <textarea className="form-control input-theme" placeholder="Enter Notes to add" value={newNote} disabled={loading} onChange={(e) => setNewNote(e.target.value)}></textarea>
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">Next Follow Date</label>
                    <div className=' datepicker-top'>
                        <DatePicker
                            format='DD/MM/YYYY'
                            onChange={(e) => { if (e) { setFollowUp(new Date(e)) } else setFollowUp(null) }}
                            value={followUp}
                            disabled={loading}
                            minDate={startOfToday()}
                            maxDate={carReq ? endOfDay(carReq) : undefined}
                        />
                    </div>
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">Phone Follow</label>
                    <Select
                        isDisabled={loading}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        options={[{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]}
                        value={follow.phoneFollow}
                        onChange={(item) => setFollow((prev) => ({ ...prev, phoneFollow: item }))}
                    />
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">Whatsapp Follow</label>
                    <Select
                        isDisabled={loading}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        options={[{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]}
                        value={follow.whatsappFollow}
                        onChange={(item) => setFollow((prev) => ({ ...prev, whatsappFollow: item }))}
                    />
                </div>
                <div className='mb-3' style={isRnr ? { display: 'none' } : undefined}>
                    <label className="form-label fw-bold">Select Remark</label>
                    <Select
                        isDisabled={loading || updateData?.value === "Rejected"}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        options={remarkOption}
                        value={remark}
                        onChange={(item) => setRemark(item)}
                    />
                </div>
                <div className='text-center my-4'>
                    <button disabled={loading} className='btn btn-theme' onClick={submitUpdate}>Submit</button>
                </div>
            </div>
            {/* } */}
        </React.Fragment>
    )
}

export default View
